// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'camera-solid';

export const Component = () => (
  <path d='M22.559 4.922h-3.88l-.575-1.39C17.72 2.528 16.954 2 15.854 2H8.67c-1.102 0-1.868.527-2.251 1.533l-.575 1.389h-3.88c-.526 0-1.005.191-1.389.575A1.917 1.917 0 0 0 0 6.886V20.63c0 .527.191 1.006.575 1.39a1.92 1.92 0 0 0 1.39.574h20.593c.526 0 1.005-.191 1.389-.575.383-.383.575-.861.575-1.389V6.886c0-.527-.192-1.006-.575-1.39a1.917 1.917 0 0 0-1.39-.574h.002Zm-7.185 11.446c-.862.91-1.915 1.34-3.113 1.34s-2.25-.43-3.113-1.34c-.862-.862-1.293-1.916-1.293-3.113 0-1.198.43-2.251 1.293-3.114.861-.861 1.915-1.293 3.113-1.293s2.25.432 3.113 1.293c.862.862 1.293 1.916 1.293 3.114 0 1.197-.431 2.25-1.293 3.113Z' />
);

export const viewBox = '0 0 25 25';
